<script setup lang="ts">
import {
  Social1Telegram,
  Social2Twitter,
  Social3Vk,
  Social4Youtube,
  Social5Inst,
  Social6Ok,
} from '@caks/uikit/icon/social'
import { ButtonIcon } from '@caks/uikit/button'

const links = [
  {
    link: 'https://t.me/sacks_group',
    icon: Social1Telegram,
  },
  // {
  //   link: '#',
  //   icon: Social2Twitter,
  // },
  {
    link: 'https://vk.com/sacksgroup',
    icon: Social3Vk,
  },
  // {
  //   link: '#',
  //   icon: Social4Youtube,
  // },
  {
    link: 'https://www.instagram.com/sacksgroup/',
    icon: Social5Inst,
  },
  // {
  //   link: '#',
  //   icon: Social6Ok,
  // },
]
</script>

<template>
  <section class="social-media">
    <a v-for="link of links" :href="link.link" target="_blank">
      <button-icon :icon="link.icon" state="circle" />
    </a>
  </section>
</template>

<style scoped lang="scss">
.social-media {
  display: flex;
  gap: 16px;
  justify-content: space-around;
  margin-bottom: 24px;

  a {
    button {
      min-height: 44px;
      min-width: 44px;

      padding: 0 !important;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
